'use client';
import { useAuth } from '@/context/AuthContext';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { checkPathAccess, getDashboardRoute } from '@/lib/auth';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const pathname = usePathname();
  const router = useRouter();
  const renderCount = useRef(0);
  renderCount.current++;

  console.log('[AuthGuard] RENDER #' + renderCount.current, { loading, user: user?.email, pathname });

  useEffect(() => {
    console.log('[AuthGuard] EFFECT', { loading, user: user?.email, pathname });
    if (loading) return;
    if (pathname === '/LoginAdminWic') return;

    const access = checkPathAccess(pathname, user?.user_type);

    if (access.isProtected) {
      if (!user) {
        const stored = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
        console.log('[AuthGuard] PROTECTED, no user, token in storage:', stored ? 'YES' : 'NO');
        if (!stored) {
          console.log('[AuthGuard] REDIRECTING TO LOGIN from:', pathname);
          router.replace('/login?callbackUrl=' + encodeURIComponent(pathname));
        }
        return;
      }
      if (!access.allowed && access.redirectUrl) {
        router.replace(access.redirectUrl);
      }
    }

    const authPaths = ['/login', '/register', '/login/employee'];
    if (user && authPaths.some(p => pathname.startsWith(p))) {
      console.log('[AuthGuard] USER ON AUTH PAGE, redirecting to dashboard');
      router.replace(getDashboardRoute(user.user_type));
    }
  }, [user, loading, pathname, router]);

  if (loading) return <div>Loading...</div>;
  return <>{children}</>;
}
